import { createApi } from '@reduxjs/toolkit/query/react';

import { Asset } from 'src/interfaces/assets.types';
import { baseQuery, useAppDispatch } from 'src/store/redux';

import { userAssetsQueryParams, UserAssetsQueryTagTypes } from './constants';

export const retailCompositeApi = createApi({
  reducerPath: 'retail-composite',
  baseQuery: baseQuery('retailComposite'),
  tagTypes: [UserAssetsQueryTagTypes.ASSETS],
  endpoints: (builder) => ({
    getUserAssets: builder.query<Asset[], string>({
      query: (userBk) => ({
        url: `/v1/users/${userBk}/assets?${userAssetsQueryParams}`,
        headers: {
          'Cache-Control': 'no-cache',
        },
      }),
      providesTags: [UserAssetsQueryTagTypes.ASSETS],
    }),
  }),
});

export const useUserAssetsRefetchWithCurrentArgs = () => {
  const dispatch = useAppDispatch();

  return () => {
    dispatch(
      retailCompositeApi.util.invalidateTags([UserAssetsQueryTagTypes.ASSETS]),
    );
  };
};

export const { useGetUserAssetsQuery } = retailCompositeApi;
